<!-- eslint-disable style/max-len -->
<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_14343_125200"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="-1"
      width="16"
      height="17"
    >
      <rect
        y="-0.166748"
        width="16"
        height="16"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_14343_125200)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.99969 11.7905L3.10148 15.4086L5.0289 9.6321L0.0742188 6.09169L6.16364 6.13972L7.99969 0.333496L9.83574 6.13972L15.9252 6.09169L10.9705 9.6321L12.8979 15.4086L7.99969 11.7905Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
